<template>
    <div>
        <span @click="add" class="buy-button" :disabled="false">
            <i v-if="innerQuantityCart > 0" class="fas fa-check"></i>
            <template v-else>+</template>
            <i class="fas fa-shopping-cart"></i>
        </span>
    </div>
</template>

<script>

import {EVENT_ON_CART_UPDATE} from "@/events";

export default {
    props: {
        cartPositionId: {
            type: Number,
            required: true
        },
        quantity: {
            type: Number,
            required: true
        },
        quantityCart: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            innerQuantity: null,//доступное количество
            innerQuantityCart: null,//количество в корзине
        }
    },
    created() {
        this.innerQuantity = this.quantity;
        this.innerQuantityCart = this.quantityCart;
        this.$root.$on(EVENT_ON_CART_UPDATE, this.onCartChanged);
    },
    beforeDestroy() {
        this.$root.$off(EVENT_ON_CART_UPDATE, this.onCartChanged);
    },
    methods: {
        add() {
            return this.$http({
                method: 'POST',
                url: '/cart/add',
                params: {id: this.cartPositionId}
            }).then(({data}) => {
                const position = data.items.filter(item => item.id === this.cartPositionId)[0];
                this.innerQuantityCart = position.quantity;
                this.$root.$emit(EVENT_ON_CART_UPDATE, data);
            });
        },
        onCartChanged(data) {
            const found = data.items.find(item => item.id === this.cartPositionId);
            if (found !== undefined) {
                this.innerQuantityCart = found.quantity;
            } else {
                this.innerQuantityCart = 0;
            }
        }
    }
}
</script>

<style lang="scss">
.buy-button {
    color: #e52b37;
    font-size: 30px;
    cursor: pointer;
}
</style>
